import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-events-timeline-skeleton-card',
  standalone: true,
  templateUrl: './events-timeline-skeleton-card.component.html',
  styleUrl: './events-timeline-skeleton-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsTimelineSkeletonCardComponent {}
